import { render, staticRenderFns } from "./FarmLiabilityLocations.vue?vue&type=template&id=561c15bd"
import script from "./FarmLiabilityLocations.vue?vue&type=script&lang=js"
export * from "./FarmLiabilityLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports